import React, { useEffect } from 'react';

import { useTable, usePagination, useSortBy } from 'react-table';


function Table({ columns = [], data, className="", initialPage = "" }) {

  const tableState = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: getInitialPage(initialPage) },
    },
    useSortBy,
    usePagination,
  )

  const { 
    getTableProps,
    headerGroups,
    prepareRow,
    page, // Instead of using 'rows', we'll use page,
    // which has only the rows for the active page

    // The rest of these things are super handy, too ;)
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize }


  } = tableState;

  let style = className === "" ? "table table-bordered table-hover table-striped mb-3" : className

  return (
    <>
      <table onLoadedData={console.log} className={style} {...getTableProps()}>
        <thead>
          {headerGroups.map(headerGroup => (
            
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => (
                <th {...column.getHeaderProps( column.getSortByToggleProps() )}>
                  {column.render('Header')}
                  <span>
                    {column.isSorted
                      ? column.isSortedDesc
                        ? ' 🔽'
                        : ' 🔼'
                      : ""}
                  </span>
                </th>
              ))}
            </tr>

          ))}
        </thead>
        <tbody>
        {page.map((row, i) => {
              prepareRow(row)
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map(cell => {
                    return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                  })}
                </tr>
              )
            })}
        </tbody>
      </table>

      <span>
        Page&nbsp;
        <strong>
          {pageIndex + 1} of {pageOptions.length}
        </strong>
      </span>

      <div className="pagination" style={{marginBottom: "1rem"}}>
        
        {pageOptions.length > 1 &&
          <div className="btn-group" role="group" aria-label="Basic example">
            <button className="btn btn-secondary" 
              onClick={() => {
                gotoPage(0)
                setInitial(0, initialPage)
              }} 
              disabled={!canPreviousPage}
            >
              {"<<"}
            </button>
            <button className="btn btn-secondary" 
              onClick={() => {
                previousPage()
                setInitial(pageIndex - 1, initialPage)
              }}
              disabled={!canPreviousPage}
            >
              {"<"}
            </button>
            <button className="btn btn-secondary" 
              onClick={() => {
                nextPage()
                setInitial(pageIndex + 1, initialPage)
              }}
              disabled={!canNextPage}
            >
              {">"}
            </button>
            <button className="btn btn-secondary" 
              onClick={() => {
                gotoPage(pageCount - 1)
                setInitial(pageCount - 1, initialPage)
              }} 
              disabled={!canNextPage}
            >
              {">>"}
            </button>
          </div>
        }
            
        
      
          
          
        <select
          value={pageSize}
          onChange={e => {
            setPageSize(Number(e.target.value))
          }}
          className={"form-control " + ((pageOptions.length > 1) ? "ml-1" : "")}
          style={{width: '120px', marginLeft: "1rem"}}
        >
          {[5, 10, 20, 30, 40, 50].map(pageSize => (
            <option key={pageSize} value={pageSize}>
              Mostrar {pageSize}
            </option>
          ))}
        </select>

      </div>
    </>
   
  )
}

export default function ReactTable({
  dataset = [], 
  columnset = [],
  filterDisabled = false,
  className = "",
  keepInitial = ""
}) {

  const columns = React.useMemo(() => columnset,  [columnset]);
  let [ filter, setFilter ] = React.useState(dataset);


  function localChange(e){
    e.preventDefault(e);
    let { value } = e.target;
    
    let cols = columnset.map( elm => elm.accessor);
    let rows = [];

    if(value)  {
      cols.forEach( (col) => {

        var results =  dataset.filter( (elm) =>  {

          if( typeof elm[col] === "number") {

            return `${elm[col]}` === value.toLowerCase();
          }else if( typeof elm[col] === "string" )  {
            
            return elm[col].toLowerCase() === value.toLowerCase();
          }else {

            return elm[col] === value.toLowerCase();
          }
          
        });
  
        results.forEach( result =>{
          rows.push(result);
        });
        
      });
      setFilter(rows);
    }else{
      
      if( dataset.length  !== filter.length ){
        setFilter(dataset);
      }
    }
    
    
  }

  useEffect(() => {
    let is_mounted = true
    if(is_mounted) setFilter(dataset);

    return () => {
      is_mounted = false
    }
  }, [setFilter, dataset])

  return (
    <>

      {!filterDisabled &&
        <div className="my-3">
          <div className="row justify-content-end">
            <div className="col-12 col-md-4 col-lg-4">
              <input className="form-control" placeholder="Search" onChange={localChange} />
            </div>
          </div>
        </div>
      }
      
      <div style={{ overflowX: 'auto' }}>
        <Table className={className} columns={columns} data={filter} initialPage={keepInitial} />
      </div>
      
    </>
  );
}

export function getInitialPage(initial = "") {

  if(initial === "")
    return 0

  const _initial = localStorage.getItem(initial) ?? 0
  return parseInt(_initial)
}

export function setInitial(initial = 0, label) {

  if(label !== "") {
    localStorage.setItem(label, initial.toString())
  }
}